import { create } from "zustand";

const AUTH_STORAGE_KEYS = [
  "sessionId",
  "initial_token",
  "token",
  "pending_initial_token",
  "pending_token",
];

const AUTH_SESSION_KEYS = ["postLoginRedirect"];

const useAuthStore = create((set) => ({
  initialAuthToken: null,
  authToken: null,
  initialUserData: null,
  userData: null,
  sessionExpired: false,
  authBootstrapStatus: "idle",

  dbInfo: localStorage.getItem("dbChoice") || "INTERNATIONAL",
  dbVersion: 0,
  loadingDB: false,
  pageTitle: " ",
  documentTitle: " ",

  setInitialAuthToken: (token) => set({ initialAuthToken: token }),
  setAuthToken: (token) => set({ authToken: token }),
  setInitialUserData: (data) => set({ initialUserData: data }),
  setUserData: (data) => set({ userData: data }),
  setSessionExpired: (expired) => set({ sessionExpired: expired }),
  setAuthBootstrapStatus: (status) => set({ authBootstrapStatus: status }),
  setDBInfo: (info) => set({ dbInfo: info }),
  setDBVersion: (version) => set({ dbVersion: version }),
  setLoadingDB: (loading) => set({ loadingDB: loading }),
  setPageTitle: (title) => set({ pageTitle: title }),
  setDocumentTitle: (title) => set({ documentTitle: title }),

  clearSession: () => {
    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    AUTH_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));

    set({
      initialAuthToken: null,
      authToken: null,
      initialUserData: null,
      userData: null,
      sessionExpired: false,
      authBootstrapStatus: "unauthenticated",
    });
  },
}));

// ─── Helper hooks (selector-based, only re-render on slice change) ──────────
export const useAuthToken = () => useAuthStore((s) => s.authToken);
export const useUserData = () => useAuthStore((s) => s.userData);
export const useSessionExpired = () => useAuthStore((s) => s.sessionExpired);
export const useAuthBootstrapStatus = () => useAuthStore((s) => s.authBootstrapStatus);
export const useIsAuthenticated = () => useAuthStore((s) => !!s.authToken);

export default useAuthStore;
